const SubscriptionTierEnum = {
  STANDARD: 'Standard',
  PREMIUM : 'Premium'
}
export default SubscriptionTierEnum
